export const GLOBAL_EXCEPTIONS_DUMMY_DATA = [
  {
    _id: "507f1f77bcf86cd799439011", // MongoDB ObjectId as string
    createdAt: "2025-07-25T10:30:00.000Z", // ISO datetime string
    updatedAt: "2025-07-25T10:30:00.000Z",
    createdBy: "user123",
    approval_authority: "Credit Committee",
    situs_exception_severity: "EV2",
    compensating_factors: [
      "Strong borrower liquidity",
      "Property in prime location",
    ],
    exception_type: "Credit Policy",
    exception_source: "Internal",
    exception_description:
      "LTV exceeds standard guidelines due to unique property characteristics",
    related_documents: ["doc_id_1", "doc_id_2"],
    exception_category: "Subject Property",
    internal_approval_granted: true,
    internal_approval_granted_by: "John Smith",
    internal_approval_granted_date: "2025-07-25T09:00:00.000Z",
    internal_approval_decision_notes: "Approved based on compensating factors",
    exception_categories: ["Valuation", "Property Type"],
    external_approval_required: true,
    external_approval_granted: false,
    external_approval_granted_by: null,
    external_approval_granted_date: null,
    /////////////////////////
    exception: "Example Exception",
    status: "Example Status",
    loan_product: "Commercial Bridge Loan",
    allowed_real_estate_property_types:
      "Office, Retail, Multifamily, Industrial",
    prohibited_real_estate_property_types:
      "Gas stations, Adult entertainment, Environmental hazards",
    allowed_borrower_types: "Individual, LLC, Corporation, Partnership",
    prohibited_borrower_types: "Foreign entities without US presence",
    allowed_borrower_entities: "Single-purpose entities, Operating companies",
    prohibited_borrower_entities: "Shell companies, Inactive entities",
    allowed_subject_property_states: "CA, NY, TX, FL, IL",
    maximum_loan_amounts: "$50,000,000",
    minimum_loan_amounts: "$1,000,000",
    quantitative_guidelines: [
      {
        name: "Debt Service Coverage Ratio",
        description: "Minimum DSCR requirement",
        guideline_text: "DSCR must be at least 1.25x",
        guideline_type: "Financial",
        guideline_category: "Quantitative",
        guideline_source_material: "Underwriting Manual",
        guideline_page_reference: "Page 22",
        related_exceptions: [],
        guideline_value: "DSCR",
        guideline_quantitative_value: "1.25",
        value_unit: "ratio",
        value_calculation: "Net Operating Income / Annual Debt Service",
        value_calculation_description:
          "Divide annual NOI by total annual debt payments",
      },
    ],
    qualitative_guidelines: [
      {
        name: "Borrower Experience",
        description: "Borrower must have relevant experience",
        guideline_text:
          "Borrower should have minimum 3 years real estate experience",
        guideline_type: "Borrower",
        guideline_category: "Qualitative",
        guideline_source_material: "Borrower Guidelines",
        guideline_page_reference: "Page 5",
        related_exceptions: [],
        guideline_value: "Experience Level",
        guideline_qualitative_value: "Minimum 3 years",
        value_reference: "Real Estate Experience",
        value_reference_description:
          "Proven track record in real estate investment or development",
      },
    ],
    borrower_guidelines: [],
    subject_property_guidelines: [],
    required_reports: [
      {
        report_name: "Property Appraisal",
        report_description: "Professional valuation of subject property",
        report_type: "Valuation Report",
        approved_vendors: [
          "ABC Appraisal",
          "XYZ Valuation",
          "Premium Appraisers",
        ],
        max_report_age: "90 days",
      },
    ],
    document_requirements: [
      {
        document_name: "Financial Statements",
        document_description: "Borrower's audited financial statements",
        document_type: "Financial Documentation",
        max_document_age: "12 months",
      },
    ],
    guideline_definitions: [
      {
        defined_term: "Net Operating Income",
        definition:
          "Total rental income minus operating expenses, excluding debt service and capital expenditures",
      },
    ],
  },
  {
    _id: "507f1f77bcf86cd799439011", // MongoDB ObjectId as string
    createdAt: "2025-07-25T10:30:00.000Z", // ISO datetime string
    updatedAt: "2025-07-25T10:30:00.000Z",
    createdBy: "user123",
    approval_authority: "Credit Committee",
    situs_exception_severity: "EV2",
    compensating_factors: [
      "Strong borrower liquidity",
      "Property in prime location",
    ],
    exception_type: "Credit Policy",
    exception_source: "Internal",
    exception_description:
      "LTV exceeds standard guidelines due to unique property characteristics",
    related_documents: ["doc_id_1", "doc_id_2"],
    exception_category: "Subject Property",
    internal_approval_granted: true,
    internal_approval_granted_by: "John Smith",
    internal_approval_granted_date: "2025-07-25T09:00:00.000Z",
    internal_approval_decision_notes: "Approved based on compensating factors",
    exception_categories: ["Valuation", "Property Type"],
    external_approval_required: true,
    external_approval_granted: false,
    external_approval_granted_by: null,
    external_approval_granted_date: null,
    /////////////////////////
    exception: "Example Exception",
    status: "Example Status",
    loan_product: "Commercial Bridge Loan",
    allowed_real_estate_property_types:
      "Office, Retail, Multifamily, Industrial",
    prohibited_real_estate_property_types:
      "Gas stations, Adult entertainment, Environmental hazards",
    allowed_borrower_types: "Individual, LLC, Corporation, Partnership",
    prohibited_borrower_types: "Foreign entities without US presence",
    allowed_borrower_entities: "Single-purpose entities, Operating companies",
    prohibited_borrower_entities: "Shell companies, Inactive entities",
    allowed_subject_property_states: "CA, NY, TX, FL, IL",
    maximum_loan_amounts: "$50,000,000",
    minimum_loan_amounts: "$1,000,000",
    quantitative_guidelines: [
      {
        name: "Debt Service Coverage Ratio",
        description: "Minimum DSCR requirement",
        guideline_text: "DSCR must be at least 1.25x",
        guideline_type: "Financial",
        guideline_category: "Quantitative",
        guideline_source_material: "Underwriting Manual",
        guideline_page_reference: "Page 22",
        related_exceptions: [],
        guideline_value: "DSCR",
        guideline_quantitative_value: "1.25",
        value_unit: "ratio",
        value_calculation: "Net Operating Income / Annual Debt Service",
        value_calculation_description:
          "Divide annual NOI by total annual debt payments",
      },
    ],
    qualitative_guidelines: [
      {
        name: "Borrower Experience",
        description: "Borrower must have relevant experience",
        guideline_text:
          "Borrower should have minimum 3 years real estate experience",
        guideline_type: "Borrower",
        guideline_category: "Qualitative",
        guideline_source_material: "Borrower Guidelines",
        guideline_page_reference: "Page 5",
        related_exceptions: [],
        guideline_value: "Experience Level",
        guideline_qualitative_value: "Minimum 3 years",
        value_reference: "Real Estate Experience",
        value_reference_description:
          "Proven track record in real estate investment or development",
      },
    ],
    borrower_guidelines: [],
    subject_property_guidelines: [],
    required_reports: [
      {
        report_name: "Property Appraisal",
        report_description: "Professional valuation of subject property",
        report_type: "Valuation Report",
        approved_vendors: [
          "ABC Appraisal",
          "XYZ Valuation",
          "Premium Appraisers",
        ],
        max_report_age: "90 days",
      },
    ],
    document_requirements: [
      {
        document_name: "Financial Statements",
        document_description: "Borrower's audited financial statements",
        document_type: "Financial Documentation",
        max_document_age: "12 months",
      },
    ],
    guideline_definitions: [
      {
        defined_term: "Net Operating Income",
        definition:
          "Total rental income minus operating expenses, excluding debt service and capital expenditures",
      },
    ],
  },
  {
    _id: "507f1f77bcf86cd799439011", // MongoDB ObjectId as string
    createdAt: "2025-07-25T10:30:00.000Z", // ISO datetime string
    updatedAt: "2025-07-25T10:30:00.000Z",
    createdBy: "user123",
    approval_authority: "Credit Committee",
    situs_exception_severity: "EV2",
    compensating_factors: [
      "Strong borrower liquidity",
      "Property in prime location",
    ],
    exception_type: "Credit Policy",
    exception_source: "Internal",
    exception_description:
      "LTV exceeds standard guidelines due to unique property characteristics",
    related_documents: ["doc_id_1", "doc_id_2"],
    exception_category: "Subject Property",
    internal_approval_granted: true,
    internal_approval_granted_by: "John Smith",
    internal_approval_granted_date: "2025-07-25T09:00:00.000Z",
    internal_approval_decision_notes: "Approved based on compensating factors",
    exception_categories: ["Valuation", "Property Type"],
    external_approval_required: true,
    external_approval_granted: false,
    external_approval_granted_by: null,
    external_approval_granted_date: null,
    /////////////////////////
    exception: "Example Exception",
    status: "Example Status",
    loan_product: "Commercial Bridge Loan",
    allowed_real_estate_property_types:
      "Office, Retail, Multifamily, Industrial",
    prohibited_real_estate_property_types:
      "Gas stations, Adult entertainment, Environmental hazards",
    allowed_borrower_types: "Individual, LLC, Corporation, Partnership",
    prohibited_borrower_types: "Foreign entities without US presence",
    allowed_borrower_entities: "Single-purpose entities, Operating companies",
    prohibited_borrower_entities: "Shell companies, Inactive entities",
    allowed_subject_property_states: "CA, NY, TX, FL, IL",
    maximum_loan_amounts: "$50,000,000",
    minimum_loan_amounts: "$1,000,000",
    quantitative_guidelines: [
      {
        name: "Debt Service Coverage Ratio",
        description: "Minimum DSCR requirement",
        guideline_text: "DSCR must be at least 1.25x",
        guideline_type: "Financial",
        guideline_category: "Quantitative",
        guideline_source_material: "Underwriting Manual",
        guideline_page_reference: "Page 22",
        related_exceptions: [],
        guideline_value: "DSCR",
        guideline_quantitative_value: "1.25",
        value_unit: "ratio",
        value_calculation: "Net Operating Income / Annual Debt Service",
        value_calculation_description:
          "Divide annual NOI by total annual debt payments",
      },
    ],
    qualitative_guidelines: [
      {
        name: "Borrower Experience",
        description: "Borrower must have relevant experience",
        guideline_text:
          "Borrower should have minimum 3 years real estate experience",
        guideline_type: "Borrower",
        guideline_category: "Qualitative",
        guideline_source_material: "Borrower Guidelines",
        guideline_page_reference: "Page 5",
        related_exceptions: [],
        guideline_value: "Experience Level",
        guideline_qualitative_value: "Minimum 3 years",
        value_reference: "Real Estate Experience",
        value_reference_description:
          "Proven track record in real estate investment or development",
      },
    ],
    borrower_guidelines: [],
    subject_property_guidelines: [],
    required_reports: [
      {
        report_name: "Property Appraisal",
        report_description: "Professional valuation of subject property",
        report_type: "Valuation Report",
        approved_vendors: [
          "ABC Appraisal",
          "XYZ Valuation",
          "Premium Appraisers",
        ],
        max_report_age: "90 days",
      },
    ],
    document_requirements: [
      {
        document_name: "Financial Statements",
        document_description: "Borrower's audited financial statements",
        document_type: "Financial Documentation",
        max_document_age: "12 months",
      },
    ],
    guideline_definitions: [
      {
        defined_term: "Net Operating Income",
        definition:
          "Total rental income minus operating expenses, excluding debt service and capital expenditures",
      },
    ],
  },
];
